import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NSSkeletonModule } from '@norfolk-southern/accessns-components';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import { CalendarVesselComponent } from '@ruby/modules/unit-train/submodules/ut-calendar-vessel/components/calendar-vessel/calendar-vessel.component';
import { UTResultsVesselComponent } from '@ruby/modules/unit-train/submodules/ut-calendar-vessel/components/ut-results-vessel/ut-results-vessel.component';
import { UTResultsVesselContainer } from '@ruby/modules/unit-train/submodules/ut-calendar-vessel/containers/ut-results-vessel/ut-results-vessel.container';
import { UTCalendarVesselRoutingModule } from '@ruby/modules/unit-train/submodules/ut-calendar-vessel/ut-calendar-vessel-routing.module';
import { UTFiltersFormModule } from '@ruby/modules/unit-train/submodules/ut-filters-form/ut-filters-form.module';
import { VesselEventDialogModule } from '@ruby/shared/dialogs/unit-train/vessel-event/vessel-event.dialog.module';

@NgModule({
  declarations: [
    CalendarVesselComponent,
    UTResultsVesselComponent,
    UTResultsVesselContainer
  ],
  exports: [
    UTResultsVesselContainer
  ],
  imports: [
    CommonModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatTooltipModule,
    MatToolbarModule,
    NSSkeletonModule,
    MatExpansionModule,
    UTCalendarVesselRoutingModule,
    UTFiltersFormModule,
    VesselEventDialogModule
  ]
})
export class UTCalendarVesselModule {}
